import React, { useState } from "react";

import { ChatBubbleProps } from "../ChatBubble/ChatBubble";
import LiveChatTab from "../LiveChatTab";
import SessionInfoTab from "../SessionInfoTab";
import { SessionInfoTabProps } from "../SessionInfoTab/SessionInfoTab";
import SpeakerInfoTab from "../SpeakerInfoTab";
import { SpeakerInfoTabProps } from "../SpeakerInfoTab/SpeakerInfoTab";
import Tabs from "../Tabs";

export interface InteractiveWidgetProps {
  session: SessionInfoTabProps;
  speaker?: SpeakerInfoTabProps;
  comments: ChatBubbleProps[];
  onNewComment: (comment: string) => void;
}

const InteractiveWidget = ({
  session,
  speaker,
  comments,
  onNewComment,
}: InteractiveWidgetProps) => {
  const items = ["Session Info", "Speaker Info", "Live Chat"];
  const [activeTab, setActiveTab] = useState(items[0]);

  const handleNewMessage = (comment: string) => {
    onNewComment(comment);
  };

  return (
    <div className="h-full p-8 bg-gray-100">
      <div className="relative w-full h-full">
        <Tabs
          tabs={items.map((item) => {
            return {
              title: item,
              onClick: () => setActiveTab(item),
            };
          })}
          activeTab={activeTab}
        />

        <div className="h-full pt-4 pb-8">
          {activeTab === items[0] ? <SessionInfoTab {...session} /> : null}

          {activeTab === items[1] ? (
            speaker ? (
              <SpeakerInfoTab {...speaker} />
            ) : (
              <div className="w-full p-4 my-4 text-sm text-center text-gray-400 bg-gray-200 rounded">
                No speaker information.
              </div>
            )
          ) : null}

          {activeTab === items[2] ? (
            <LiveChatTab comments={comments} onNewMessage={handleNewMessage} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default InteractiveWidget;
